import React from "react";
import "./ResetPassword.css";
import Button from "@mui/material/Button";
import deemedLogo from "./resources/logo.png";
import googleImg from "./resources/google.svg";
import facebookImg from "./resources/facebook.svg";
import eye from "../../../resources/assets/eye.svg";
import eyeOff from "../../../resources/assets/eye-off.svg";
import goBackIcon from "../../../resources/assets/goback.svg";
import OtpInput from "react-otp-input";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { ApiEndpoint } from "config/constants/apiConstants";
import { Alert } from "@mui/material";

function ResetPassword() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const [error, setError] = React.useState("");
  const [values, setValues] = React.useState({
    password: "",
    showPassword: false,
  });
  const [values1, setValues1] = React.useState({
    password: "",
    showPassword: false,
  });
  const handleClickShowPassword = () => {
    setValues({ ...values, showPassword: !values.showPassword });
  };
  const handleClickShowPassword1 = () => {
    setValues1({ ...values1, showPassword: !values1.showPassword });
  };

  const handlePasswordChange = (prop) => (event) => {
    setValues({ ...values, [prop]: event.target.value });
  };
  const handlePasswordChange1 = (prop) => (event) => {
    setValues1({ ...values1, [prop]: event.target.value });
  };

  const signUp = async () => {
    if (values.password === "" || values.password !== values1.password) {
      setError("Password does not match");
      return;
    }
    const data = {
      email: state.email,
      userTypes: ["PATIENT", "GUARDIAN"],
      code: state.code,
      password: values.password,
    };
    axios
      .post(ApiEndpoint.UPDATE_PASSWORD, data)
      .then((res) => {
        alert("Password changed successfully");
        navigate("/login");
      })
      .catch((err) => {
        setError(err?.response?.data?.message);
      });
  };

  return (
    <div className="loginBgDoc2">
      <div className="wrapper-center2">
        <div className="row log_wrapper2">
          <div className="text-white log_left2">
            <img className="logo-img2" src={deemedLogo} alt="logo" />
            <h4 className="log_saying2">
              A doctor is not a mechanic.
              <br />
              A car doesn't react with a<br />
              mechanic, but a human <br /> being does.
            </h4>
            <h4 className="log_saying_name2">- Randa Haines</h4>
          </div>
          <div className="log_right2">
            <div className="log_card2">
              <div className="goBackIconWrapper" onClick={() => navigate(-1)}>
                <img className="otpGoBack" src={goBackIcon} />
              </div>
              <h3 className="welcome_text2">Reset Password</h3>
              <p className="welcome_des2 title-des-reset-resetPassword">
                Set the new password for your account so you can login and
                access all the features.
              </p>

              <center>
                <div className="password_wrapper2 marginBottom-input-resetPass">
                  <input
                    type={values.showPassword ? "text" : "password"}
                    onChange={handlePasswordChange("password")}
                    value={values.password}
                    className="log_input_password2"
                    placeholder="Password"
                  ></input>
                  <Button
                    type="contained"
                    onClick={handleClickShowPassword}
                    style={{ padding: "0", height: "100%" }}
                  >
                    {values.showPassword ? (
                      <img
                        src={eyeOff}
                        style={{ width: "15px", color: "#677294;" }}
                        alt=""
                      />
                    ) : (
                      <img
                        src={eye}
                        style={{ width: "15px", color: "#677294;" }}
                        alt=""
                      />
                    )}
                  </Button>
                </div>
                <div className="password_wrapper2">
                  <input
                    type={values1.showPassword ? "text" : "password"}
                    onChange={handlePasswordChange1("password")}
                    value={values1.password}
                    className="log_input_password2"
                    placeholder="Re-enter Password"
                  ></input>
                  <Button
                    type="contained"
                    onClick={handleClickShowPassword1}
                    style={{ padding: "0", height: "100%" }}
                  >
                    {values1.showPassword ? (
                      <img
                        src={eyeOff}
                        style={{ width: "15px", color: "#677294;" }}
                        alt=""
                      />
                    ) : (
                      <img
                        src={eye}
                        style={{ width: "15px", color: "#677294;" }}
                        alt=""
                      />
                    )}
                  </Button>
                </div>
              </center>
              <div className="rp_row justify-content-center marginBottom">
                {error && (
                  <Alert severity="error" style={{ margin: "8px" }}>
                    {error}
                  </Alert>
                )}
              </div>

              <div className="button_field margin-bottom-submitBtn-resetPass">
                {/* <button className="gradientButton" type="submit" onClick={signUp}>
                  Continue
                </button> */}
                <Button
                  variant="contained"
                  type="submit"
                  className="payBtn log_submit_btn"
                  onClick={(e) => {
                    signUp();
                  }}
                >
                  Continue
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export { ResetPassword };
